import { render, staticRenderFns } from "./ProductAssignmentDiscounts.vue?vue&type=template&id=7f7e5e4a&"
import script from "./ProductAssignmentDiscounts.vue?vue&type=script&lang=js&"
export * from "./ProductAssignmentDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./ProductAssignmentDiscounts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports